module.exports = __webpack_public_path__ + "static/Film_Editing_p2a-dbadf8a0f71c7efeb6ccc0ccb43d5483.mp4";